export enum ModuleNavigationItemStatus {
  'Active' = 'active',
  'InActive' = 'inActive',
  'Undefined' = 'undefined',
}
